export const POLL_INTERVAL_MS = 10000;
export const MAX_WORKFLOWS = 100;
export const OVERFLOW_RESERVE_PX = 48;
